import { injectIntl } from "react-intl";

import { intlShape } from "../../shapes";
import ErrorPage from "./ErrorPage";
import { errorTypes } from "./ErrorTypes";

type Props = {
  intl?: intlShape;
  isFullPage?: boolean;
};

export function Unknown({ intl, isFullPage = false }: Props) {
  return (
    <ErrorPage
      isFullPage={isFullPage}
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      header={intl.formatMessage({ id: "unknown_error.header" })}
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      details={intl.formatMessage({ id: "unknown_error.details" })}
      errorType={errorTypes.unknown}
    />
  );
}

// warning config might not be available
export default injectIntl(Unknown);
